import * as $http from '@/axios'

// 上傳文件
export function uploadFileToS3(data) {
  return $http.post('/basic/s3/upload', data, { headers: {
    'Content-Type': 'multipart/form-data',
  }})
}

// 上傳圖片
export function uploadImageToS3(data) {
  return $http.post('/basic/image/upload', data, { headers: {
    'Content-Type': 'multipart/form-data',
  }})
}

// 获取白名单用户的权限
export function getWhiteListUserPermissions() {
  return $http.get('/gray/scale/config')
}

// 清空未讀提示消息
export function clearRedCircle(data) {
  return $http.post('/reddot/clean', data)
}

// 發送驗證碼
export function getSmsCode(data) {
  return $http.post('/user/telephone/login/sms/send', data)
}

// 提現歷史
export function getWithdrawHistory(data) {
  return $http.post('/account/withdraw/history', data)
}

// 申請提現
export function applyWithdraw(data) {
  return $http.post('/account/withdraw/apply', data)
}

// 设置用户信息
export function saveUserInfo(data) {
  return $http.post('/user/save', data)
}

// 查詢自己是否拉黑對方
export function checkBlack(data) {
  return $http.post('/user/black/self/check', data)
}

// 关注列表
export function getFollowList(data) {
  return $http.post('/user/follow/list', data)
}

// 关注/取关对方
export function followUser(data) {
  return $http.post('/user/follow/operation', data)
}

// 查询用户被邀请信息
export function getInviterUuid(data) {
  return $http.get('/inviterB/find/inviter', data)
}

// 获取追踪关系
export function getFollowInfo(params) {
  return $http.get('/user/follow/info', params)
}

/**
 * @description: 創建或者修改銀行帳戶信息
 * @param {*} data
 * @return {*}
 */
export function saveBankInfo(data) {
  return $http.post('/account/bank/save', data)
}

/**
 * @description: 獲取銀行帳戶信息
 * @param {*} data
 * @return {*}
 */
export function getBankInfo() {
  return $http.post('/account/bank/get')
}


/**
 * @description: 提現
 * @param {*} data
 * @return {*}
 */
export function withdrawApplyV2(data) {
  return $http.post('/account/withdraw/apply/v2', data)
}
